import { render, staticRenderFns } from "./AddTagButton.vue?vue&type=template&id=0fb3fd88"
import script from "./AddTagButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTagButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports